import screenfull from 'screenfull'
import uiConfiguration from '../uiConfiguration'
import { AssetsService } from 'shared-utils'

const fullPageIcon = AssetsService.getSvgIcon('full-screen.svg')
const fullPageExitIcon = AssetsService.getSvgIcon('full-screen-exit.svg')

function showLogoInFullscreen(customUIName) {
  return uiConfiguration.getConfigurationFor(customUIName, 'showLogoInFullScreen')
}

function showCreditsInsteadOfSimpleLogo(customUIName) {
  return uiConfiguration.getConfigurationFor(customUIName, 'showCreditsInsteadOfSimpleLogo')
}

export function setupFullscreenButton(viewer, customUIName) {
  if (!screenfull.isEnabled) {
    return
  }
  screenfull.on('change', () => {
    let showLogo
    document.getElementById('full-page').classList.toggle('full-screen-active')
    if (screenfull.isFullscreen) {
      showLogo = showLogoInFullscreen(customUIName) ? 'block' : 'none'
    } else {
      showLogo = showCreditsInsteadOfSimpleLogo(customUIName) ? 'block' : 'none'
    }
    document.querySelector(`#logoContainer`).style.display = showLogo

    const fullScreenButton = document.querySelector(`#full-page > button`)
    if (screenfull.isFullscreen) {
      fullScreenButton.innerHTML = `<img src="${fullPageExitIcon}"/>`
    } else {
      fullScreenButton.innerHTML = `<img src="${fullPageIcon}"/>`
    }
  })

  const fullScreenButton = document.getElementById('full-page')
  fullScreenButton.addEventListener('click', e => {
    if (screenfull.isEnabled) {
      screenfull.toggle().catch(e => console.warn(e))
    }
  })
}
